var _g;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgTable(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 14.092,
    height: 18.5,
    viewBox: "0 0 14.092 18.5",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "information-2",
    transform: "translate(-61)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_77",
    "data-name": "Path 77",
    d: "M331.542,12.807h3.476L331,8.789v3.476A.542.542,0,0,0,331.542,12.807Z",
    transform: "translate(-260.244 -8.471)",
    fill: "#707070"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_78",
    "data-name": "Path 78",
    d: "M62.626,18.5h10.84a1.628,1.628,0,0,0,1.626-1.626V5.42H71.3a1.628,1.628,0,0,1-1.626-1.626V0H62.626A1.628,1.628,0,0,0,61,1.626V16.874A1.628,1.628,0,0,0,62.626,18.5Zm3.252-9.792H71.3a.542.542,0,1,1,0,1.084h-5.42a.542.542,0,1,1,0-1.084Zm0,2.168H71.3a.542.542,0,0,1,0,1.084h-5.42a.542.542,0,0,1,0-1.084Zm0,2.168H71.3a.542.542,0,1,1,0,1.084h-5.42a.542.542,0,1,1,0-1.084ZM63.71,8.708a.542.542,0,1,1-.542.542A.542.542,0,0,1,63.71,8.708Zm0,2.168a.542.542,0,1,1-.542.542A.542.542,0,0,1,63.71,10.876Zm0,2.168a.542.542,0,1,1-.542.542A.542.542,0,0,1,63.71,13.044Z",
    fill: "#707070"
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgTable);
export default __webpack_public_path__ + "static/media/table.f9ec193715247c600ff0c1c0a114a4de.svg";
export { ForwardRef as ReactComponent };